module.exports = __webpack_public_path__ + "img/hr-sand-2.af995d0c.png";